/** Feature flags, fixed at build time from the Vite env (`.env*`). A feature is off unless its variable is "1". */
export const FEATURES = {
  /** The composer's `/` menu of Skills (GET /agent-v2/skills). Off: no menu, no button, no request. */
  skills: import.meta.env.VITE_FEATURE_SKILLS === '1',
};
